import {Component, Injector, OnInit} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { finalize } from 'rxjs/operators';

import { AuthService } from '../../../services/auth.service';
import { DialogService } from '../../../../shared/dialog/services/dialog.service';
import { InfoDialogComponent } from '../../../../shared/dialog/components/dialogs/info-dialog/info-dialog.component';
import { DialogDataModel } from '../../../../shared/dialog/models/dialog-data.model';
import AudioHelper from '../../../../audio/helpers/audio.helper';

@Component({
  selector: 'oauth-login-handle',
  templateUrl: './oauth-login.component.html',
})
export class OauthLoginComponent implements OnInit {
  protected audioHelper: AudioHelper;
  /**
   * Constructor
   *
   * @param {AuthService} authService
   * @param {ActivatedRoute} route
   * @param {Router} router
   * @param {DialogService} dialogService
   * @param injector
   */
  public constructor(
    private authService: AuthService,
    private route: ActivatedRoute,
    private router: Router,
    private dialogService: DialogService,
    private injector: Injector,
  ) {
    this.audioHelper = injector.get(AudioHelper);
  }

  /**
   * When the component is initialized
   *
   * @return void
   */
  public ngOnInit(): void {
    this.authService.authCode = this.route.snapshot.queryParams['code'];
    this.authService.authProvider = this.route.snapshot.params['idp'];

    // cleaning the queryParams: navigate back to itself, without the queryParams
    this.router.navigate([], {
      queryParams: {
        code: null,
        scope: null,
        session_state: null,
        authuser: null,
        prompt: null,
      },
      queryParamsHandling: 'merge',
    }).then(() => {
      this.authService.doSocialLogin()
        .pipe(
          finalize(() => {
            this.router.navigate([this.authService.redirectUrl || '/course']).then();
          }),
        )
        .subscribe(
          () => { },
          (error) => {
            const data = new DialogDataModel();
            if (error.title && error.text) {
              data.title = error.title;
              data.text = error.text;
            } else {
              data.title = error.error.message;
            }
            this.dialogService.open(InfoDialogComponent, data);
            this.audioHelper.playAudio('error');
          },
        );
    });
  }
}
